/**
 * 快找
 */
export default {
  //快找 跟踪查询 客服查询记录 新增 客户查询记录 受理类型options https://imagecdn.ymm56.com/ymmfile/static/resource/2fb1c7bf-de22-412d-875a-b73b166ba696.png
  // { id: 4, text: '改单' },{ id: 5, text: '异动' } 86346
  //{ id: 4, text: '改单' },{ id: 5, text: '理赔' },{ id: 6, text: '减款' },{ id: 7, text: '待跟踪' } 86935
  // { id: 4, text: '回单已传' } 85780
  customer_inquiry_record_custom_options_edit: ['86346', '86935'], //改单
  customer_inquiry_record_custom_options_modify: ['86346'], //异动
  customer_inquiry_record_custom_options_complain: ['86935'], //理赔
  customer_inquiry_record_custom_options_reduce: ['86935'], //减款
  customer_inquiry_record_custom_options_track: ['86935'], //待跟踪
  customer_inquiry_record_custom_options_receipt_has_been_sent: ['85780'], // 回单已传 202506261553580378907 85780且其他选择非必填

  // 快找界面增加公共能力，实现tooltip元素，本次先定制
  // https://imagecdn.ymm56.com/ymmfile/static/resource/b705b9b4-f030-4232-ae94-139a820bc032.png
  show_quick_page_tool_tip: ['90100', '88114', '82984'], // 202507211947352071776、202507181800026703467

  // 转送表格，增加蓝桥定位
  // https://imagecdn.ymm56.com/ymmfile/static/resource/0706c700-33e0-49ca-acd9-5c426c552054.png
  zs_add_lq_position: ['90696'], // 202508051434296139636
  // 配载表格，隐藏蓝桥定位
  // https://imagecdn.ymm56.com/ymmfile/static/resource/ac27c7c7-9881-475f-b148-96784dc78b47.png
  pz_del_lq_position: ['98951'], // 202508051158046771212
  // 快找 再来一单位置调整
  offset_copy_order: ['90816', '93579', '84213', '71808', '86823'], // 202502201029589405081 202506031733432231923 202509041506136405171
  one_click_download: ['90782'], // 202510061111330671239 快找 关联图片 一键下载
  // 快找页面，重量单位展示/吨
  weight_unit_display_ton: ['82111', '96051', '77703', '97879'],
  // 快找页面，重量单位展示/T 202510171104354733004
  weight_unit_display_T: ['89008'],
  hide_bottom_table: ['99502'], // 202510221012154675496
  extend_address_height: ['92230'], // 202510171155082577795
  hide_sf: ['99370'], // 202510191805452406098
  // 运单号前面加上企业id前缀202510101154484002713
  add_enterprise_id_prefix_to_waybill_number: ['91270'],
  // 202510082014228673094 不允许删除快找里面的备注
  cannot_delete_kz_remark: ['85246'],
  // 202511171519533134518
  remove_control_data_hide: ['77855'],
  // 202511271616102006122 快找隐藏操作日期
  hide_opt_date_kz: ['97091', '95526', '96535'],
  // 展示货物存放位置
  show_goods_storage_location: ['99579'], // 202512030814367001622
  // 客服查询记录不校验非空 202603041618017101235
  customer_record_not_validate_empty: ['90100','60033'],
  //限制运单单类型关联图片数量
  limit_bill_upload_img_number: ['85341','90100']
}
